<template>
  <div class="recipientList">
    <div class="d-flex recipient__title">
      <div>{{ title }}</div>
    </div>
    <div class="ml-1" data-cy="recipient-list-container">
      <button
        v-for="recipient in recipients"
        :key="recipient.email_address"
        class="recipient d-flex align-items-center mb-2"
        :data-cy="`default-recipient-button-${recipient.email_address}`"
        @click="handleToggleChecked(recipient)"
      >
        <Checkbox
          :error="error"
          :model-value="recipient.checked"
          class="recipient__checkbox mb-0 mr-1 align-self-baseline"
          :disabled="isCheckboxDisabled(recipient)"
          :data-cy="`default-recipient-checkbox-${recipient.email_address}`"
        />
        <div data-cy="default-recipient-name" class="recipient__name">
          <div v-if="recipient.name">
            <div class="d-inline-block">
              <strong class="mr-1">{{ recipient.name }}</strong>
            </div>
            <div class="d-inline-block">({{ recipient.email_address }})</div>
          </div>
          <div v-else>
            <span>{{ recipient.email_address }}</span>
          </div>
        </div>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import Checkbox from "@/components/Checkbox.vue";
import { EmailRecipient } from "../types";

const props = defineProps({
  error: {
    type: Boolean,
    default: () => false
  },
  disabled: {
    type: Boolean,
    default: () => false
  },
  title: {
    type: String,
    default: ""
  },
  recipients: {
    type: Array as () => EmailRecipient[],
    default: () => []
  }
});
const emit = defineEmits(["toggle-checked"]);

function handleToggleChecked(recipient: EmailRecipient) {
  if (isCheckboxDisabled(recipient)) return;
  emit("toggle-checked", recipient);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const isCheckboxDisabled = (recipient: EmailRecipient) => {
  return props.disabled;
};
</script>

<style lang="scss" scoped>
.recipientList {
  .recipient {
    border: none;
    background: none;
    outline: none !important;
    padding: 0;
    width: calc(100% - 60px);
    &__title {
      font-weight: 600;
      border-bottom: 1px solid var(--gray-border-color);
      margin-bottom: 10px;
    }
    &__checkbox {
      pointer-events: none;
    }
    &__name {
      word-break: break-all;
      overflow-wrap: anywhere;
      text-overflow: ellipsis;
      display: block;
      text-wrap: wrap;
      text-align: left;
      * {
        display: inline;
      }
    }
  }
}
</style>
